export const pagesDevicesRuleAndPolicyEn = {
  backToList: 'Back to list',
  btn: {
    addRule: 'Add rule',
    addRuleGroup: 'Add rule group',
    changeOrder: 'Change order'
  },
  cancel: 'Cancel',
  createRule: 'Create rule',
  delete: 'Delete',
  deleteRuleBody: 'This rule will be permanently deleted.',
  deleteRuleBodyInclusions: '{{count}} exception assignment(s) linked to this rule will also be deleted.',
  deleteRuleGroupBody: 'This rule group will be permanently deleted.',
  deleteRuleGroupDisabled: 'Remove all member rules before deleting the group.',
  deleteRuleGroupTitle: 'Delete {{name}}?',
  deleteRuleTitle: 'Delete {{name}}?',
  description: 'Configure assignment rules by people group and device group.',
  dialog: {
    createRuleGroupTitle: 'Add rule group',
    editRuleGroupTitle: 'Edit rule group'
  },
  edit: 'Edit',
  editRule: 'Edit rule',
  filter: {
    all: 'All',
    deviceGroup: 'Device group',
    memberGroup: 'People group',
    moveDown: 'Move down',
    moveUp: 'Move up',
    resultCount: '{{count}} items'
  },
  form: {
    description: 'Description',
    deviceGroup: 'Device group',
    deviceGroupNoResults: 'No matching device groups found',
    deviceGroupPlaceholder: 'Select a device group',
    deviceGroupSearchPlaceholder: 'Search device groups...',
    groupName: 'Rule group name',
    independent: 'Independent rule',
    manageDeviceGroups: 'Manage device groups',
    name: 'Rule name',
    optional: '(optional)',
    orderInGroup: 'Order in group',
    orderInGroupOptionalHint: 'Leave blank to add at the end',
    peopleGroups: 'People groups',
    peopleGroupsAddButton: 'Add',
    peopleGroupsEmpty: 'Add people groups using the button above (at least one required)',
    peopleGroupsNoCandidates: 'No people groups available to add',
    peopleGroupsNoResults: 'No matching people groups found',
    peopleGroupsSearchPlaceholder: 'Search people groups...',
    preview: {
      deviceGroupLabel: 'Device group',
      empty: {
        devices: 'No devices match this device group.',
        persons: 'No members match the selected people groups.'
      },
      error: 'Failed to load preview. Check your selections.',
      helpText: 'Shows members matching the selected people groups (OR) and devices in the device group. Rule group first-match (FIRST_TAKE_WIN) evaluation is not applied.',
      helpTitle: 'About this preview',
      incomplete: 'Select people groups and a device group to preview affected members and devices.',
      tabs: {
        devices: 'Target devices',
        persons: 'Target members'
      },
      title: 'Assignment preview'
    },
    ruleGroup: 'Rule group membership',
    ruleGroupsLoadError: 'Failed to load rule groups. Rule group selection is unavailable.',
    sections: {
      basic: {
        help: 'Identification for the rule. Use a name and description that explain its purpose to operators.',
        title: 'Basic information'
      },
      deviceGroup: {
        help: 'Specify which devices should be assigned to the target members.',
        title: 'Device group'
      },
      peopleGroups: {
        help: 'Specify the members this rule applies to.',
        title: 'People groups'
      }
    },
    validation: {
      deviceGroupRequired: 'Select a device group',
      nameRequired: 'Enter a rule name',
      orderInGroupInvalid: 'Order in group must be a positive integer',
      peopleGroupsRequired: 'Select at least one people group'
    }
  },
  inclusions: {
    add: 'Add exception',
    columns: {
      actions: 'Actions',
      alertTarget: 'Exception alert type',
      assignmentRule: 'Target rule',
      device: 'Device',
      expiresAt: 'Valid until',
      member: 'Member',
      reason: 'Reason'
    },
    delete: 'Delete',
    deleteConfirmBody: 'This exception assignment will be permanently deleted.',
    deleteConfirmTitle: 'Delete exception for {{member}}?',
    dialog: {
      assignmentRule: 'Target rule',
      assignmentRulePlaceholder: 'Select target rule',
      cancel: 'Cancel',
      clearDevice: 'Clear device',
      createTitle: 'Add exception assignment',
      device: 'Device',
      devicePlaceholder: 'Select a device',
      editTitle: 'Edit exception assignment',
      expiresAt: 'Valid until',
      expiresAtOptional: 'No expiry',
      inclusionType: 'Exception type',
      inclusionTypePersonDevice: 'Member + device',
      inclusionTypePersonRule: 'Member + rule',
      person: 'Member',
      personPlaceholder: 'Select a member',
      reason: 'Reason',
      reasonPlaceholder: 'Why this exception is allowed',
      save: 'Save',
      validation: {
        assignmentRuleRequired: 'Select a target rule',
        deviceRequired: 'Select a device',
        personRequired: 'Select a member',
        reasonRequired: 'Enter a reason'
      }
    },
    edit: 'Edit',
    empty: 'No exception assignments for this rule.',
    expiry: {
      daysLeft: '{{n}} days left',
      daysOverdue: '{{n}} days overdue',
      today: 'Expires today'
    },
    help: 'Members listed here are exempt from this rule (violation whitelist).',
    loadError: 'Failed to load exception assignments.',
    systemEmpty: 'No exception assignments.',
    systemHelp: 'Cross-rule exceptions for To be assigned or Violated assignment alerts. Register member + target rule for To be assigned, or member + device for Violated assignment.',
    systemTitle: 'Exception assignments (cross-rule)',
    title: 'Exception assignments'
  },
  listTitle: 'Assignment rules: Assignment',
  loadError: 'Failed to load rules.',
  pageTitle: 'Rules & Policy',
  reorderSaveError: 'Failed to save rule order. The list has been refreshed.',
  reorderSavePartialError: 'Failed to save order for {{failed}} rule group(s). Saved changes are applied. The list has been refreshed.',
  save: 'Save',
  searchPlaceholder: 'Search by people group or device group...',
  sideTab: {
    assignment: 'Assignment',
    assignmentRules: 'Assignment rules',
    closeSideTab: 'Close side tab',
    openSideTab: 'Open side tab'
  },
  systemExceptionsName: 'System exceptions',
  systemRule: {
    description: 'Manage cross-rule exception assignments (member+rule or member+device).'
  },
  table: {
    deviceCount: 'Devices',
    deviceCountValue: '{{count}}',
    deviceGroup: 'Device group',
    inclusionCount: '{{count}} exceptions',
    memberGroup: 'People group',
    noMembers: '— No members —',
    order: 'Order',
    rule: 'Rule',
    rulesInGroup: '{{count}} rules',
    targetPersonCount: 'People',
    toBeAssignedCount: 'To be assigned',
    unnamedRule: '(Unnamed)'
  },
  wizard: {
    completeDialog: {
      createMessage: 'Rule created.',
      detailLink: 'View rule',
      listLink: 'Back to rules list'
    },
    confirm: {
      description: 'Description',
      deviceGroup: 'Device group',
      name: 'Rule name',
      orderInGroup: 'Order in group',
      peopleGroups: 'People groups',
      ruleGroup: 'Rule group',
      tailOrder: 'Add at end (position {{order}})',
      title: 'Review your entries'
    },
    navigation: {
      basic: 'Basic information',
      confirm: 'Confirm',
      target: 'Assignment targets',
      titleCreate: 'Create rule'
    },
    stepTitle: {
      basic: '1. Basic information',
      confirm: '3. Confirm',
      target: '2. Assignment targets'
    },
    submitError: 'Some entries are invalid. Please review your inputs.'
  }
};